import { Directive, Input, Renderer2, ElementRef } from '@angular/core';
var AmdButtonDirective = /** @class */ (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function AmdButtonDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    Object.defineProperty(AmdButtonDirective.prototype, "color", {
        /**
         * @param {?} theme
         * @return {?}
         */
        set: function (theme) {
            this.renderer.addClass(this.elementRef.nativeElement, "amd-button--" + theme);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdButtonDirective.prototype.ngOnInit = function () {
        this.renderer.addClass(this.elementRef.nativeElement, "amd-button");
        this.renderer.addClass(this.elementRef.nativeElement, "amd-button--default");
    };
    AmdButtonDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[amdButton]'
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdButtonDirective.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    AmdButtonDirective.propDecorators = {
        'color': [{ type: Input },],
    };
    return AmdButtonDirective;
}());
export { AmdButtonDirective };
function AmdButtonDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdButtonDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdButtonDirective.ctorParameters;
    /** @type {?} */
    AmdButtonDirective.propDecorators;
    /** @type {?} */
    AmdButtonDirective.prototype.elementRef;
    /** @type {?} */
    AmdButtonDirective.prototype.renderer;
}
//# sourceMappingURL=button.directive.js.map
//# sourceMappingURL=button.directive.js.map
